import {
  postApiPesAccessTokenSaveLoginUser,
  postApiPesAccessTokenUserLogOut,
} from '@/services/pes/accessToken';
import { User } from 'oidc-client-ts';

const TOKEN_KEY = 'pes_token';
const SESSION_STATE_KEY = 'pes_session_state';
const isLogin = () => {
  return (
    !!localStorage.getItem(TOKEN_KEY) &&
    !!localStorage.getItem(SESSION_STATE_KEY)
  );
};
const getToken = () => {
  return localStorage.getItem(TOKEN_KEY);
};
const getSessionState = () => {
  return localStorage.getItem(SESSION_STATE_KEY);
};
const clearLocalToken = () => {
  [TOKEN_KEY, SESSION_STATE_KEY].forEach((key) =>
    localStorage.removeItem(key),
  );
};
const setToken = async (user: User) => {
  const items = {
    [TOKEN_KEY]: user.access_token,
    [SESSION_STATE_KEY]: user.session_state ?? '',
  };
  Object.entries(items).forEach(([key, value]) =>
    localStorage.setItem(key, value),
  );

  const result = await postApiPesAccessTokenSaveLoginUser();
  if (result.success) {
  }
};
const clearToken = async () => {
  try {
    // 调用后端接口，清除 Redis 缓存并登出 IdP 中的用户会话。
    const result = await postApiPesAccessTokenUserLogOut({
      skipErrorHandler: true,
    });
    if (!result?.success) {
      console.warn('服务端登出未完成，已清除本地登录信息。');
    }
  } catch (error) {
    console.warn('服务端登出失败，已清除本地登录信息。', error);
  } finally {
    clearLocalToken();
  }
};
export {
  clearLocalToken,
  clearToken,
  getSessionState,
  getToken,
  isLogin,
  setToken,
};
